import React from 'react';
import PropTypes from 'prop-types';

// Organization glyph: a corporate office tower (windows + entrance), single-color
// with cut-out windows via fillRule evenodd. Deliberately distinct from
// SiteActiveSvg (factory/plant = a site) while staying in the same "building"
// visual family. viewBox matches SiteActiveSvg (0 0 16 15) so sizing is 1:1.
const OrganisationSvg = ({ width, height, fill }) => (
  <svg width={width} height={height} viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={fill}
      fillRule="evenodd"
      d="
        M3 2 H13 V14 H3 Z
        M4.8 3 H6.4 V4.4 H4.8 Z
        M7.2 3 H8.8 V4.4 H7.2 Z
        M9.6 3 H11.2 V4.4 H9.6 Z
        M4.8 5.1 H6.4 V6.5 H4.8 Z
        M7.2 5.1 H8.8 V6.5 H7.2 Z
        M9.6 5.1 H11.2 V6.5 H9.6 Z
        M4.8 7.2 H6.4 V8.6 H4.8 Z
        M7.2 7.2 H8.8 V8.6 H7.2 Z
        M9.6 7.2 H11.2 V8.6 H9.6 Z
        M6.9 10.2 H9.1 V14 H6.9 Z
      "
    />
  </svg>
);

OrganisationSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
};

OrganisationSvg.defaultProps = {
  width: 16,
  height: 15,
  fill: 'green',
};

export default OrganisationSvg;
